import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const ArrowUpIcon: React.FC<IconProps> = (props) => {
  const { width, height, fontSize, color } = {
    ...defaultIconProps, ...props
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      height={height}
      width={width}
      style={{ fontSize }}
      {...props}
    >
      <path
        id="icon"
        d="M11 8.79999L8.1 11.7C7.91667 11.8833 7.68334 11.975 7.4 11.975C7.11667 11.975 6.88334 11.8833 6.7 11.7C6.51667 11.5167 6.425 11.2833 6.425 11C6.425 10.7167 6.51667 10.4833 6.7 10.3L11.3 5.69999C11.5 5.49999 11.7333 5.39999 12 5.39999C12.2667 5.39999 12.5 5.49999 12.7 5.69999L17.3 10.3C17.4833 10.4833 17.575 10.7167 17.575 11C17.575 11.2833 17.4833 11.5167 17.3 11.7C17.1167 11.8833 16.8833 11.975 16.6 11.975C16.3167 11.975 16.0833 11.8833 15.9 11.7L13 8.79999V17C13 17.2833 12.9042 17.5208 12.7125 17.7125C12.5208 17.9042 12.2833 18 12 18C11.7167 18 11.4792 17.9042 11.2875 17.7125C11.0958 17.5208 11 17.2833 11 17V8.79999Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowUpIcon;